import { render, staticRenderFns } from "./ServiceSubstances.vue?vue&type=template&id=2a277162"
import script from "./ServiceSubstances.vue?vue&type=script&lang=js"
export * from "./ServiceSubstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports